import { customerValidate } from '../../application/dtos/customer_validate'

export class customerEntity {
    constructor({id}){
        this.id = id;
    }

    isValid() {
        return customerValidate(this);
    }
}